module.exports = __webpack_public_path__ + "static/media/bus-tracking.0915a94d.jpg";